import { useEffect, useState } from "react";

export const ZendeskSupportUrl = "https://highgroundsolutions.zendesk.com/hc/en-us/";

export const AlertStatus = {
  Error: -1,
  All: 0,
  Sent: 1,
  Scheduled: 2,
  Draft: 3,
  Received: 4,
};

export const AlertType = {
  All: 0,
  Voice: 1,
  Email: 2,
  Text: 3,
  VoiceIVR: 4,
  RSS: 7,
  EmergencyText: -1,
};

export const TemplateType = {
  ALL: 0,
  TTS: 1,
  EMAIL: 2,
  SMS: 3,
  VOICE: 4,
};

export const CommunicationMethod = {
  TTS: 1,
  Email: 2,
  Text: 3,
  Voice: 4,
};

export const TEMPLATE_TABS = [
  { id: "all", label: "All" },
  { id: "tts", label: "Text to Speech" },
  { id: "email", label: "Email" },
  { id: "sms", label: "SMS" },
  { id: "voice", label: "Voice" },
];

export function tabToCommunicationType(tabId) {
  switch (tabId) {
    case "tts":
      return TemplateType.TTS;
    case "email":
      return TemplateType.EMAIL;
    case "sms":
      return TemplateType.SMS;
    case "voice":
      return TemplateType.VOICE;
    default:
      return 0;
  }
}

export function commMethodLabel(type) {
  switch (type) {
    case AlertType.Voice:
      return "Voice";
    case AlertType.Email:
      return "Email";
    case AlertType.Text:
      return "SMS";
    case AlertType.VoiceIVR:
      return "Text to Speech";
    default:
      return "\u2014";
  }
}

export function commMethodMeta(type) {
  switch (type) {
    case CommunicationMethod.Voice:
      return { label: "Voice", iconClass: "fa fa-microphone" };
    case CommunicationMethod.Email:
      return { label: "Email", iconClass: "fa fa-envelope" };
    case CommunicationMethod.Text:
      return { label: "Text", iconClass: "fa fa-mobile" };
    case CommunicationMethod.TTS:
      return { label: "TTS", iconClass: "fa fa-volume-up" };
    default:
      return null;
  }
}

export const MobileWidth = 1200;
export const TabletWidth = 1200;
export const AnimationLength = 250;
export const MAX_DISPLAY = 5;
export const SmsCharLimit = 612;
export const SmsCreditTiers = [
  { range: "1\u2013160 chars", label: "1 message" },
  { range: "161\u2013306 chars", label: "2 messages" },
  { range: "307\u2013460 chars", label: "3 messages" },
  { range: "461\u2013612 chars", label: "4 messages" },
];

export function isMobile() {
  return window.innerWidth < MobileWidth;
}
export function isTablet() {
  // Detect iPad by user agent and touch points, or by width
  const isIpad =
    /iPad|Macintosh/.test(navigator.userAgent) && navigator.maxTouchPoints > 1;
  return (
    isIpad ||
    (window.innerWidth >= MobileWidth && window.innerWidth < TabletWidth)
  );
}
export function useIsDesktop() {
  const [isDesktop, setIsDesktop] = useState(window.innerWidth > 1201);

  useEffect(() => {
    const handleResize = () => {
      setIsDesktop(window.innerWidth > 1201);
    };

    // Add event listener to resize event
    window.addEventListener("resize", handleResize);

    // Cleanup the event listener when the component unmounts
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return isDesktop;
}
export const removeTags = (str) => {
  if (str === null || str === "") return false;
  else str = str.toString();

  // Regular expression to identify HTML tags inthe input string.
  //  Replacing the identified HTML tag with a null string.
  return str.replace(/(<([^>]+)>)/gi, "");
};
export const Path = {
  /* Messages */
  Messages: "/messages",
  PeopleMessages: "/people-messages/:id",
  Dashboard: "/",
  PeopleDashboard: "/people-dashboard/:id",
  UserDashboard: "/contact",
  /* Alerts */
  Track: "/track",
  TrackSent: "/track/sent",
  TrackScheduled: "/track/scheduled",
  TrackDrafts: "/track/drafts",
  Archived: "/track/archived",
  SendQuickLaunch: "/send/quick",
  Templates: "/templates",
  CreateTemplate: "/template/create",
  EditTemplate: "/template/edit/:id",
  Send: "/send",
  SendAddition: "/send/",
  SendEmergency: "/send/emergency",
  SendEmergencyAddition: "/send/emergency/",
  Sent: "/successful",
  AlertDetails: "/alert",
  /* People */
  People: "/people",
  PeopleAddition: "/people/",
  AddPerson: "/people/add",
  AddPersonAddition: "/people/add/",
  ImportPerson: "/people/import",
  ArchivedPeople: "/people/archived",
  /* Groups */
  Groups: "/groups",
  GroupAddition: "/groups/",
  PeopleGroups: "/people-groups/:id",
  GroupMembers: "/group-members/:id",
  /* Admin Reports */
  Reports: "/reports",
  ReportCommunication: "/reports/communication",
  ReportCommunicationAddition: "/reports/communication/",
  ReportRecent: "/reports/recent",
  ReportRecentAddition: "/reports/recent/",
  ReportInvalidContacts: "/reports/invalidcontacts",
  ReportInvalidContactsAddition: "/reports/invalidcontacts/",
  ReportOptOut: "/reports/optout",
  ReportOptOutAddition: "/reports/optout/",
  ReportLocation: "/reports/location",
  /* User Profile */
  Profile: "/settings/profile",
  MyAccount: "/settings/myaccount",
  /* Settings */
  Settings: "/settings",
  Admin: "/admin",
  AdminInvalidContacts: "/admin/invalidcontacts",
  AdminInvalidPhone: "/admin/invalidphone",
  AdminRecent: "/admin/recent",
  AdminLogins: "/admin/logins",
  AdminEmailOptOut: "/admin/optout/email",
  AdminSmsOptOut: "/admin/optout/sms",
  AdminAttendance: "/admin/attendance",
  AdminLunch: "/admin/lunch",
  AdminLocation: "/admin/location",
  AdminCommuication: "/admin/communication",
  AccountDetails: "/settings/account",
  AccountSummary: "/settings/summary",
  AccountPlan: "/settings/plan",
  AccountPayment: "/settings/payment",
  SettingsPassword: "/settings/password",
  SettingsUsername: "/settings/username",
  SettingsVoice: "/settings/voice",
  SettingsSms: "/settings/sms",
  SettingsLanguage: "/settings/language",
  SettingsContact: "/settings/contact",
  SettingsPhoneCode: "/settings/phone-code",
  SettingsMessageHistory: "/settings/message-history",
  SettingsAddress: "/settings/address",
  SettingsGroups: "/settings/groups",
  /* Help */
  Help: "/help",
  SetupPassword: "/setup-password",
  // Account
  Account: "/account",
  AccountGeneral: "/account/general",
  AccountMessaging: "/account/messaging",
  AccountPermissions: "/account/permissions",
  AccountPlanUsage: "/account/plan-usage",
  AccountAlertCategories: "/account/alert-categories",
  AccountImports: "/account/imports",
  // Embed Routes
  SendAlertEmbed: "/send-message-embed",
  SendEmbedEmergency: "/send-message-embed/emergency",
  EmbedMessages: "/messages-embed",
};

export const AccountTabs = [
  { title: "General", path: "/account/general" },
  { title: "Messaging", path: "/account/messaging" },
  { title: "Permissions", path: "/account/permissions" },
  { title: "Plan & Payment", path: "/account/plan-usage" },
  { title: "Alert Categories", path: "/account/alert-categories" },
  { title: "Imports & Auto-Calls", path: "/account/imports" },
];

export const TIMEZONE_OPTIONS = [
  { value: "Eastern", label: "Eastern" },
  { value: "Central", label: "Central" },
  { value: "Mountain", label: "Mountain" },
  { value: "Pacific", label: "Pacific" },
  { value: "Alaska", label: "Alaska" },
  { value: "Hawaii", label: "Hawaii" },
  { value: "Guam", label: "Guam" },
  { value: "GMT +1", label: "GMT +1" },
  { value: "GMT +2", label: "GMT +2" },
  { value: "GMT +3", label: "GMT +3" },
  { value: "GMT +4", label: "GMT +4" },
  { value: "GMT +5.5", label: "GMT +5.5" },
];

export const EMAIL_EDITOR_OPTIONS = [
  { value: "HTML", label: "HTML" },
  { value: "Plain Text", label: "Plain Text" },
];

export const BILLING_CYCLE_OPTIONS = [
  { value: "Monthly", label: "Monthly" },
  { value: "Annually", label: "Annually" },
];

export const USD_CURRENCY_FORMATTER = new Intl.NumberFormat("en-US", {
  style: "currency",
  currency: "USD",
  minimumFractionDigits: 2,
  maximumFractionDigits: 4,
});

export const PLAN_OPTIONS = {
  Monthly: [
    { value: "starter_monthly", label: "Starter Monthly (500 credits)" },
    { value: "standard_monthly", label: "Standard Monthly (2,000 credits)" },
    { value: "premium_monthly", label: "Premium Monthly (5,000 credits)" },
  ],
  Annually: [
    { value: "starter_annual", label: "Starter Annual (6,000 credits)" },
    { value: "standard_annual", label: "Standard Annual (24,000 credits)" },
    { value: "premium_annual", label: "Premium Annual (60,000 credits)" },
  ],
};

export const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
export const EXPIRY_MM_YY_REGEX = /^(0[1-9]|1[0-2])\/\d{2,4}$/;

export const MESSAGING_DEFAULTS = {
  replyToEmail: "",
  emailSendName: "",
  callerId: "",
  emergencyCallerId: "",
  transferNumber: "",
  defaultAreaCode: "",
  timeZone: "Central",
  defaultEmailEditor: "HTML",
  smsHeader: "",
  preMsgTemplateId: "",
  postMsgTemplateId: "",
  emailResultsTo: "",
  templateOptions: [],
};

// ─── Template Create / Edit ───────────────────────────────────────────────────

export const SMS_CHAR_LIMIT = 612;
export const TTS_CHAR_LIMIT = 1600;
export const TTS_CHAR_WARNING_LIMIT = 1440;
export const TEMPLATE_ID_MAX = 50;
export const MAX_TTS_DURATION_SECONDS = 120;
// "Trim to 1:45" target — leaves headroom under the 2 minute hard limit.
export const TTS_TRIM_TARGET_SECONDS = 105;
// Approximate spoken-word rate per language, used only to estimate/preview duration
// before conversion. The actual budget check always uses the measured audio duration.
export const DEFAULT_TTS_WPM = 150;
export const TTS_SPEAKING_RATE_WPM_BY_LANGUAGE = {
  en: 150,
  es: 160,
  fr: 155,
  de: 145,
  pt: 158,
  it: 155,
  zh: 120,
  vi: 150,
  ko: 140,
  ja: 130,
};

export const COMM_METHODS = [
  { id: AlertType.Text, label: "Text", icon: "fa-mobile" },
  { id: AlertType.Email, label: "Email", icon: "fa-envelope" },
  { id: AlertType.Voice, label: "Voice", icon: "fa-microphone" },
  { id: AlertType.VoiceIVR, label: "TTS", icon: "fa-volume-up" },
];

// ─── Template Grid – filter names ────────────────────────────────────────────
export const TEMPLATE_FILTER = {
  Category: "Template Category",
  CreatedBy: "Created By",
  FromDate: "From Date",
  ToDate: "To Date",
};

// ─── Template Grid – sort column keys ────────────────────────────────────────
export const TEMPLATE_SORT_COLUMN = {
  Name: "name",
  CommMethod: "comm-method",
  Category: "category",
  CreatedBy: "created-by",
  LastSaved: "last-saved",
};

export function getTemplateCharLimit(commMethod) {
  if (commMethod === AlertType.Text) return SMS_CHAR_LIMIT;
  if (commMethod === AlertType.VoiceIVR) return TTS_CHAR_LIMIT;
  return null;
}

export function generateTemplateId() {
  return Math.random().toString(36).substring(2, 7).toUpperCase();
}

export function generateVoiceFileName() {
  const now = new Date();
  const mm = String(now.getMonth() + 1).padStart(2, "0");
  const dd = String(now.getDate()).padStart(2, "0");
  const yyyy = now.getFullYear();
  const hh = String(now.getHours()).padStart(2, "0");
  const min = String(now.getMinutes()).padStart(2, "0");
  const ss = String(now.getSeconds()).padStart(2, "0");
  return `Voice_${mm}-${dd}-${yyyy}_${hh}-${min}-${ss}`;
}

export function getAlertTypeConfig(commMethod) {
  switch (commMethod) {
    case AlertType.Text:
      return { AlertTypeId: 3, TemplateType: 3 };
    case AlertType.Email:
      return { AlertTypeId: 2, TemplateType: 2 };
    case AlertType.Voice:
      return { AlertTypeId: 1, TemplateType: 4 };
    case AlertType.VoiceIVR:
      return { AlertTypeId: 1, TemplateType: 1 };
    default:
      return { AlertTypeId: null, TemplateType: null };
  }
}

export function getCommMethodFromConfig(alertTypeId, templateType) {
  if (alertTypeId === 3) return AlertType.Text;
  if (alertTypeId === 2) return AlertType.Email;
  if (alertTypeId === 1 && templateType === 4) return AlertType.Voice;
  if (alertTypeId === 1 && templateType === 1) return AlertType.VoiceIVR;
  return AlertType.Text;
}

export const PeopleTab = {
  All: 0,
  Employee: 1,
  Managers: 3,
  Admin: 4,
};

export const UserRole = {
  Member: 1,
  Staff: 3,
  Admin: 4,
};
export const UserRoleName = {
  User: 99,
  Anonymous: 0,
  Student: 1,
  Staff: 2,
  Faculty: 3,
  Admin: 4,
  Universal_Admin: 5,
  Export: -2,
};

export const DEFAULT_STUDENT_LABEL = "Student";
export const DEFAULT_FACULTY_LABEL = "Faculty";

export const USStates = [
  { label: "Alabama", value: "AL" },
  { label: "Alaska", value: "AK" },
  { label: "Arizona", value: "AZ" },
  { label: "Arkansas", value: "AR" },
  { label: "California", value: "CA" },
  { label: "Colorado", value: "CO" },
  { label: "Connecticut", value: "CT" },
  { label: "Delaware", value: "DE" },
  { label: "Florida", value: "FL" },
  { label: "Georgia", value: "GA" },
  { label: "Hawaii", value: "HI" },
  { label: "Idaho", value: "ID" },
  { label: "Illinois", value: "IL" },
  { label: "Indiana", value: "IN" },
  { label: "Iowa", value: "IA" },
  { label: "Kansas", value: "KS" },
  { label: "Kentucky", value: "KY" },
  { label: "Louisiana", value: "LA" },
  { label: "Maine", value: "ME" },
  { label: "Maryland", value: "MD" },
  { label: "Massachusetts", value: "MA" },
  { label: "Michigan", value: "MI" },
  { label: "Minnesota", value: "MN" },
  { label: "Mississippi", value: "MS" },
  { label: "Missouri", value: "MO" },
  { label: "Montana", value: "MT" },
  { label: "Nebraska", value: "NE" },
  { label: "Nevada", value: "NV" },
  { label: "New Hampshire", value: "NH" },
  { label: "New Jersey", value: "NJ" },
  { label: "New Mexico", value: "NM" },
  { label: "New York", value: "NY" },
  { label: "North Carolina", value: "NC" },
  { label: "North Dakota", value: "ND" },
  { label: "Ohio", value: "OH" },
  { label: "Oklahoma", value: "OK" },
  { label: "Oregon", value: "OR" },
  { label: "Pennsylvania", value: "PA" },
  { label: "Rhode Island", value: "RI" },
  { label: "South Carolina", value: "SC" },
  { label: "South Dakota", value: "SD" },
  { label: "Tennessee", value: "TN" },
  { label: "Texas", value: "TX" },
  { label: "Utah", value: "UT" },
  { label: "Vermont", value: "VT" },
  { label: "Virginia", value: "VA" },
  { label: "Washington", value: "WA" },
  { label: "West Virginia", value: "WV" },
  { label: "Wisconsin", value: "WI" },
  { label: "Wyoming", value: "WY" },
];

export const CustomContactTypes = {
  HomePhone: "Home Phone",
  WorkPhone: "Work Phone",
  CellPhone: "Cell Phone",
  Address: "Address",
  Email: "Email",
};

export const DISCARD_ROUTES = {
  messages: "/messages",
  groups: "/groups",
  dashboard: "/",
  people: "/people",
};

export const STATUS_TABS_EMAIL = [
  { key: "All", label: "All" },
  { key: "Sent", label: "Sent" },
  { key: "Delivered", label: "Delivered" },
  { key: "Opened", label: "Opened" },
  { key: "Unopened", label: "Unopened" },
  { key: "Clicked", label: "Clicked" },
  { key: "SpamReported", label: "Spam Reported" },
  { key: "Bounced", label: "Bounced" },
  { key: "Unsubscribed", label: "Unsubscribed" },
];

export const STATUS_TABS_SMS = [
  { key: "All", label: "All" },
  { key: "Sent", label: "Sent" },
  { key: "Delivered", label: "Delivered" },
  { key: "Pending", label: "Pending" },
  { key: "Failed", label: "Failed" },
  { key: "OptOut", label: "Opt-Out" },
];

export const STATUS_TABS_VOICE = [
  { key: "All", label: "All" },
  { key: "Answered", label: "Answered" },
  { key: "Unanswered", label: "Unanswered" },
];

export const STATUS_TO_CODE_EMAIL = {
  All: 0,
  Sent: 1,
  Delivered: 2,
  Opened: 3,
  Unopened: 4,
  Clicked: 5,
  SpamReported: 6,
  Bounced: 7,
  Unsubscribed: 8,
};

export const STATUS_TO_CODE_SMS = {
  All: 0,
  Sent: 1,
  Delivered: 2,
  Pending: 3,
  Failed: 4,
  OptOut: 5,
};

export const STATUS_TO_CODE_VOICE = {
  All: 0,
  Answered: 1,
  Unanswered: 2,
  Human: 3,
  Machine: 4,
  Fax: 5,
  Unknown: 6,
  Confirmed: 7,
  Unconfirmed: 8,
};

export const VOICE_SUMMARY_FILTER = {
  ALL_INTENDED: 0,
  ANSWERED: 1,
  UNANSWERED: 2,
  HUMAN: 3,
  MACHINE: 4,
  FAX: 5,
  UNKNOWN: 6,
  ALL_ACTUAL: 7,
};

export const SMS_SUMMARY_FILTER = {
  ALL: 0,
  SENT: 1,
  DELIVERED: 2,
  PENDING: 3,
  FAILED: 4,
  OPT_OUT: 5,
};

export const SCHEDULE_DAYS_OF_WEEK = [
  { id: 0, short: "S", label: "Sun" },
  { id: 1, short: "M", label: "Mon" },
  { id: 2, short: "T", label: "Tue" },
  { id: 3, short: "W", label: "Wed" },
  { id: 4, short: "T", label: "Thu" },
  { id: 5, short: "F", label: "Fri" },
  { id: 6, short: "S", label: "Sat" },
];

export const SCHEDULE_HOUR_OPTIONS = Array.from({ length: 12 }, (_, index) =>
  String(index + 1),
);

export const SCHEDULE_MINUTE_OPTIONS = Array.from({ length: 12 }, (_, index) =>
  String(index * 5).padStart(2, "0"),
);

export const SCHEDULE_MERIDIEM_OPTIONS = [
  { value: "AM", label: "AM" },
  { value: "PM", label: "PM" },
];

export const SCHEDULE_REPEAT_PERIOD_OPTIONS = [
  { value: "days", label: "Day(s)" },
  { value: "weeks", label: "Week(s)" },
  { value: "months", label: "Month(s)" },
  { value: "years", label: "Year(s)" },
];

export function getScheduleTimezone() {
  return Intl.DateTimeFormat().resolvedOptions().timeZone || "America/New_York";
}

function getTimeZoneNamePart(formatter) {
  return formatter
    .formatToParts(new Date())
    .find((part) => part.type === "timeZoneName")?.value;
}

function isGmtOffsetLabel(label) {
  return /^GMT(?:[+-]\d{1,2}(?::\d{2})?)?$/i.test(label);
}

function abbreviateTimeZoneLabel(label) {
  const uppercaseToken = label.match(/\b[A-Z]{2,5}\b/);
  if (uppercaseToken?.[0]) return uppercaseToken[0];

  const words = label.match(/[A-Za-z]+/g) || [];
  const abbreviation = words
    .map((word) => word[0])
    .join("")
    .toUpperCase();
  if (abbreviation.length >= 2 && abbreviation.length <= 5) return abbreviation;

  return null;
}

export function getScheduleTimeZoneLabel(timezone) {
  try {
    const shortFormatter = new Intl.DateTimeFormat(undefined, {
      timeZone: timezone,
      timeZoneName: "short",
    });

    const shortLabel = getTimeZoneNamePart(shortFormatter);
    if (shortLabel && !isGmtOffsetLabel(shortLabel)) return shortLabel;

    const longFormatter = new Intl.DateTimeFormat("en-US", {
      timeZone: timezone,
      timeZoneName: "long",
    });

    const longLabel = getTimeZoneNamePart(longFormatter);
    if (longLabel) {
      const abbreviation = abbreviateTimeZoneLabel(longLabel);
      if (abbreviation && !isGmtOffsetLabel(abbreviation)) return abbreviation;
      if (!isGmtOffsetLabel(longLabel)) return longLabel;
    }

    return timezone;
  } catch {
    return timezone;
  }
}

export function normalizeScheduleDateValue(dateValue) {
  if (!dateValue) return null;
  const parsed = new Date(dateValue);
  return isNaN(parsed.getTime()) ? null : parsed;
}

export function toScheduleStartOfDay(date) {
  return new Date(date.getFullYear(), date.getMonth(), date.getDate());
}

export function isFutureScheduleDateTime(candidateDate) {
  return candidateDate.getTime() > new Date().getTime();
}

export function mergeScheduleDateWithTime(
  baseDate,
  selectedHour,
  selectedMinute,
  selectedPeriod,
) {
  const mergedDate = new Date(baseDate);
  let hour = parseInt(selectedHour, 10);

  if (selectedPeriod === "PM" && hour !== 12) hour += 12;
  if (selectedPeriod === "AM" && hour === 12) hour = 0;

  mergedDate.setHours(hour, parseInt(selectedMinute, 10), 0, 0);
  return mergedDate;
}

export function formatScheduleDateKey(date) {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  const hour = String(date.getHours()).padStart(2, "0");
  const minute = String(date.getMinutes()).padStart(2, "0");
  return `${year}-${month}-${day}T${hour}:${minute}`;
}

export function buildScheduleRecurringPatternKey({
  startDate,
  hour,
  minute,
  period,
  repeatEvery,
  repeatPeriod,
  repeatOnDays,
  endType,
  endOnDate,
  afterOccurrences,
}) {
  const sortedDays = [...repeatOnDays].sort((a, b) => a - b).join(",");
  const endValue =
    endType === "on"
      ? `${endOnDate?.getFullYear() || ""}-${(endOnDate?.getMonth() || 0) + 1}-${endOnDate?.getDate() || ""}`
      : String(afterOccurrences);

  return [
    startDate.getFullYear(),
    startDate.getMonth(),
    startDate.getDate(),
    hour,
    minute,
    period,
    repeatEvery,
    repeatPeriod,
    sortedDays,
    endType,
    endValue,
  ].join("|");
}

export function formatScheduleInputDate(date) {
  if (!date) return "";
  return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, "0")}-${String(date.getDate()).padStart(2, "0")}`;
}

export function generateScheduleRecurringDates({
  startDate,
  hour,
  minute,
  period,
  repeatEvery,
  repeatPeriod,
  repeatOnDays,
  endType,
  endOnDate,
  afterOccurrences,
}) {
  const startDateOnly = toScheduleStartOfDay(startDate);
  const endDateOnly = endOnDate ? toScheduleStartOfDay(endOnDate) : null;
  const repeatValue = parseInt(repeatEvery, 10);
  const maxOccurrences = parseInt(afterOccurrences, 10);
  const selectedDays = [...repeatOnDays].sort((a, b) => a - b);
  const generatedDates = [];
  const maxIterations = 1200;

  if (!repeatValue || repeatValue < 1) return generatedDates;

  const pushIfValid = (candidateDateOnly) => {
    if (
      endType === "on" &&
      endDateOnly &&
      candidateDateOnly.getTime() > endDateOnly.getTime()
    ) {
      return false;
    }

    const withTime = mergeScheduleDateWithTime(
      candidateDateOnly,
      hour,
      minute,
      period,
    );
    if (isFutureScheduleDateTime(withTime)) {
      generatedDates.push(withTime);
      if (endType === "after" && generatedDates.length >= maxOccurrences) {
        return false;
      }
    }

    return true;
  };

  const getMonthPatternFallbackDate = (year, month) => {
    const startWeekday = startDateOnly.getDay();
    const startWeekIndex = Math.floor((startDateOnly.getDate() - 1) / 7);
    const monthLastDate = new Date(year, month + 1, 0).getDate();
    const isLastWeekdayPattern = startDateOnly.getDate() + 7 > monthLastDate;

    if (isLastWeekdayPattern) {
      const candidate = new Date(year, month + 1, 0);
      while (candidate.getDay() !== startWeekday) {
        candidate.setDate(candidate.getDate() - 1);
      }
      return candidate;
    }

    const firstWeekdayDate = new Date(year, month, 1);
    while (firstWeekdayDate.getDay() !== startWeekday) {
      firstWeekdayDate.setDate(firstWeekdayDate.getDate() + 1);
    }

    const candidate = new Date(firstWeekdayDate);
    candidate.setDate(candidate.getDate() + startWeekIndex * 7);
    return candidate.getMonth() === month ? candidate : null;
  };

  if (repeatPeriod === "days") {
    for (let index = 0; index < maxIterations; index += 1) {
      const candidate = new Date(startDateOnly);
      candidate.setDate(candidate.getDate() + index * repeatValue);

      if (
        endType === "on" &&
        endDateOnly &&
        candidate.getTime() > endDateOnly.getTime()
      ) {
        break;
      }

      if (!pushIfValid(candidate)) break;
    }

    return generatedDates;
  }

  if (repeatPeriod === "months") {
    const startDayOfMonth = startDateOnly.getDate();

    for (let index = 0; index < maxIterations; index += 1) {
      const totalMonths = startDateOnly.getMonth() + index * repeatValue;
      const year = startDateOnly.getFullYear() + Math.floor(totalMonths / 12);
      const month = ((totalMonths % 12) + 12) % 12;

      let candidate = new Date(year, month, startDayOfMonth);
      if (candidate.getMonth() !== month) {
        candidate = getMonthPatternFallbackDate(year, month);
      }
      if (!candidate) continue;

      if (
        endType === "on" &&
        endDateOnly &&
        candidate.getTime() > endDateOnly.getTime()
      ) {
        break;
      }

      if (!pushIfValid(candidate)) break;
    }

    return generatedDates;
  }

  if (repeatPeriod === "years") {
    const month = startDateOnly.getMonth();
    const day = startDateOnly.getDate();

    for (let index = 0; index < maxIterations; index += 1) {
      const year = startDateOnly.getFullYear() + index * repeatValue;
      const candidate = new Date(year, month, day);

      if (candidate.getMonth() !== month || candidate.getDate() !== day) {
        continue;
      }

      if (
        endType === "on" &&
        endDateOnly &&
        candidate.getTime() > endDateOnly.getTime()
      ) {
        break;
      }

      if (!pushIfValid(candidate)) break;
    }

    return generatedDates;
  }

  const effectiveDays =
    selectedDays.length > 0 ? selectedDays : [startDateOnly.getDay()];
  const startWeekday = startDateOnly.getDay();
  const dayOffsets = effectiveDays
    .map((dayId) => (dayId - startWeekday + 7) % 7)
    .sort((a, b) => a - b);

  for (let index = 0; index < maxIterations; index += 1) {
    const weekStart = new Date(startDateOnly);
    weekStart.setDate(weekStart.getDate() + index * repeatValue * 7);

    if (
      endType === "on" &&
      endDateOnly &&
      weekStart.getTime() > endDateOnly.getTime()
    ) {
      break;
    }

    for (
      let offsetIndex = 0;
      offsetIndex < dayOffsets.length;
      offsetIndex += 1
    ) {
      const candidate = new Date(weekStart);
      candidate.setDate(candidate.getDate() + dayOffsets[offsetIndex]);

      if (
        endType === "on" &&
        endDateOnly &&
        candidate.getTime() > endDateOnly.getTime()
      ) {
        continue;
      }

      if (!pushIfValid(candidate)) {
        return generatedDates;
      }
    }
  }

  return generatedDates;
}

export function formatScheduleCardDate(date) {
  return date.toLocaleDateString(undefined, {
    weekday: "short",
    month: "short",
    day: "numeric",
    year: "numeric",
  });
}

export function formatScheduleCardTime(date) {
  return date.toLocaleTimeString(undefined, {
    hour: "numeric",
    minute: "2-digit",
  });
}

export function formatScheduleShortDate(date) {
  return date.toLocaleDateString(undefined, {
    month: "short",
    day: "numeric",
    year: "numeric",
  });
}

/* Import Users */
export const IMPORT_USERS_ENABLED = false;
export const ACCEPTED_FILE_TYPES = ".xls,.xlsx";
export const IMPORT_TEMPLATE_PATH = "/lib/templates/import-users-template.xlsx";
export const IMPORT_TEMPLATE_FILENAME = "import-users-template.xlsx";
export const IMPORT_TEMPLATE_HEADERS = [
  "Unique ID",
  "First Name",
  "Last Name",
  "Home Phone",
  "Cell Phone 1",
  "Cell Phone 2",
  "Cell Phone 3",
  "Work Phone 1",
  "Work Phone 2",
  "Primary Email",
  "Email 2",
  "Email 3",
  "Group 1",
  "Group 2",
  "Group 3",
  "Group 4",
  "Location",
];

export const IMPORT_STEPS = [
  { label: "Step 1", description: "Upload File" },
  { label: "Step 2", description: "Import Settings" },
  { label: "Step 3", description: "Data Mapping" },
];

export const IMPORT_PROGRESS_MAP = { 1: "10%", 2: "50%", 3: "100%" };

export const IMPORT_USER_FIELDS = ["First Name", "Last Name", "Unique ID"];

export const IMPORT_CONTACT_FIELDS = [
  "Home Phone",
  "Cell Phone 1",
  "Cell Phone 2",
  "Cell Phone 3",
  "Work Phone 1",
  "Work Phone 2",
  "Primary Email",
  "Email 2",
  "Email 3",
];

export const IMPORT_GROUP_FIELDS = ["Group 1", "Group 2", "Group 3", "Group 4"];

export const ALL_IMPORT_SYSTEM_FIELDS = [
  ...IMPORT_USER_FIELDS,
  ...IMPORT_CONTACT_FIELDS,
  ...IMPORT_GROUP_FIELDS,
];

export const IMPORT_SECTION_CONFIG = [
  { key: "user", title: "User Information", fields: IMPORT_USER_FIELDS },
  {
    key: "contact",
    title: "Contact Information",
    fields: IMPORT_CONTACT_FIELDS,
  },
  { key: "group", title: "Group Information", fields: IMPORT_GROUP_FIELDS },
];

export const IMPORT_FIELD_ALIASES = {
  // Email aliases
  email1: "Primary Email",
  email: "Primary Email",
  primaryemail: "Primary Email",
  email2: "Email 2",
  email3: "Email 3",
  // Phone aliases
  homephone: "Home Phone",
  cellphone1: "Cell Phone 1",
  cellphone: "Cell Phone 1",
  cellphone2: "Cell Phone 2",
  cellphone3: "Cell Phone 3",
  workphone1: "Work Phone 1",
  workphone: "Work Phone 1",
  workphone2: "Work Phone 2",
  // Name aliases
  firstname: "First Name",
  lastname: "Last Name",
  uniqueid: "Unique ID",
  // Group aliases
  group1: "Group 1",
  group: "Group 1",
  group2: "Group 2",
  group3: "Group 3",
  group4: "Group 4",
};

export const IMPORT_REQUIRED_FIELDS = ["First Name"];

export function normalizeField(str) {
  return str
    .trim()
    .toLowerCase()
    .replace(/[_\s]+/g, "");
}

export const AlertPriorityLevel = {
  NonEmergency: 0,
  Emergency: 10,
};

export const USER_TYPE_LABELS = {
  1: "Member",
  2: "Faculty",
  3: "Staff",
  4: "Admin",
  5: "Super Admin",
};

export function UserTypeBadge({ userTypeId }) {
  const label = USER_TYPE_LABELS[userTypeId] || ("Type " + userTypeId);
  return (
    <span className={`people-role-badge role-${userTypeId}`}>{label}</span>
  );
}

export const MaxAlertCategories = 5;
